<template>
  <div class="sanitas-magazine-podcast-container">
    <h2 v-if="titleLabel" v-html="titleLabel" />
    <div
      v-if="description"
      class="sanitas-magazine-podcast-description"
      v-html="description"
    />
    <div
      v-if="podcastSrc"
      class="sanitas-magazine-podcast-iframe"
      :style="{ marginBottom: marginBottom + 'px' }"
    >
      <iframe
        :id="podcastId"
        ref="podbeanIframe"
        width="100%"
        :src="podcastSrc"
        :height="podcastHeight"
        :scrolling="scrolling"
        :frameborder="0"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { trackAction, tracker } from '@/helpers/tracker'

const API_SRC = 'https://pbcdn1.podbean.com/fs1/player/api.js'

export default {
  name: 'SanitasMagazinePodcast',

  props: {
    titleLabel: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    podcastId: {
      type: String,
      required: true,
    },
    podcastSrc: {
      type: String,
      required: true,
    },
    podcastWidth: {
      type: String,
      default: '0',
    },
    podcastHeight: {
      type: String,
      default: null,
    },
    scrolling: {
      type: String,
      default: null,
    },
    marginBottom: {
      type: String,
      default: '0',
    },
  },

  mounted() {
    this.initAPI()
    this.jumpToElement()
  },

  methods: {
    /**
     * Load API (if not yet done)
     */
    initAPI() {
      const id = 'podbeanapi'
      if (!document.getElementById(id)) {
        const el = document.createElement('script')
        el.setAttribute('src', API_SRC)
        el.setAttribute('id', id)
        document.body.appendChild(el)
      }

      this.load()
    },

    jumpToElement() {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          scrollToElement()
        }
      }

      function scrollToElement() {
        if (!window.location.hash) {
          return
        }
        const hashName = window.location.hash.substr(1)
        const element = document.getElementById(hashName)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }
    },

    load() {
      let intervals = 20

      const hasBeenTracked = {}

      let interval = setInterval(() => {
        if (window.PB) {
          // eslint-disable-next-line
          const podbeanWidget = new PB(this.$refs.podbeanIframe)
          podbeanWidget.bind('PB.Widget.Events.PLAY', () =>
            this.track('ComHFPodcastPlayed'),
          )
          podbeanWidget.bind('PB.Widget.Events.FINISH', () =>
            this.track('ComHFPodcastConsumed100'),
          )

          podbeanWidget.bind('PB.Widget.Events.PLAY_PROGRESS', event => {
            const _pos = parseInt(event.data.relativePosition * 100)

            if ([25, 50, 75, 95].includes(_pos)) {
              if (!hasBeenTracked[_pos]) {
                hasBeenTracked[_pos] = true
                this.track(`ComHFPodcastConsumed${_pos}`)
              }
            }
          })

          clearInterval(interval)
        }

        if (intervals === 0) {
          clearInterval(interval)
        }

        intervals--
      }, 200)
    },

    setTrackingData(id, url) {
      tracker.set({
        data: {
          podcast: {
            id: this.$refs.podbeanIframe.id,
            url: encodeURIComponent(this.$refs.podbeanIframe.src),
          },
        },
      })
    },

    track(key) {
      this.setTrackingData()
      trackAction(key)
    },
  },
}
</script>
